export const KEYCHAIN_PRODUCT_ID = 'gid://shopify/Product/7914638868654';
export const KEYCHAIN_VARIANT_ID = '43743631835310';
const CREATE_YOUR_OWN_HEAD_NUMERIC_ID = '8946479890606';
export const CREATE_YOUR_OWN_HEAD_PRODUCT_ID = `gid://shopify/Product/${CREATE_YOUR_OWN_HEAD_NUMERIC_ID}`;

export const isKeychainProductId = (id) => id === KEYCHAIN_PRODUCT_ID;
export const isCreateYourOwnHeadProductId = (id) => {
    if (!id) return false;
    return String(id).split('/').pop() === CREATE_YOUR_OWN_HEAD_NUMERIC_ID;
};
export const isKeychainVariantId = (variantId) => {
    if (!variantId) return false;
    const numeric = variantId.split?.('/')?.pop?.() || variantId; // supports gid://shopify/ProductVariant/<id>
    return numeric === KEYCHAIN_VARIANT_ID;
};
